import React, { Fragment } from "react";
import { injectIntl, FormattedMessage } from "react-intl";

const CountrySelect = props => {
  var langCode = (props.intl.locale).substring(0,2);
  var collator = new Intl.Collator(langCode);
  return (
    <Fragment>
      <FormattedMessage id="countryselect.select">
        {message => (
          <option key={message} value="" disabled>
            {message}
          </option>
        )}
      </FormattedMessage>
      <option value="" disabled />
      {Object.entries(props.intl.messages.Countries)
        .sort(function(o1, o2) {
          var textA = o1[1].toUpperCase();
          var textB = o2[1].toUpperCase();
          return collator.compare(textA, textB);
        })
        .map(([key, value]) => (
          <option key={value} value={key}>
            {value}
          </option>
        ))}
    </Fragment>
  );
};

export default injectIntl(CountrySelect);
